import { HeaderLayoutConfig } from 'ict24h-themes-react/lib/esm/components/UI/Header/Header'
import { E_OFFICE_PREFIX_URL } from '../../e-office-layout/constants/config.e-office-layout'

export const configDMSLayout: HeaderLayoutConfig = {
  appName: ' ICT24h Tài liệu ',
  logoLink: 'https://ict24h.net',
  backgroundColor: '#454791',
  color: '#000',
}

export const DMS_SHORT_PREFIX_URL = '/dms'
export const DMS_PREFIX_URL = `${E_OFFICE_PREFIX_URL}${DMS_SHORT_PREFIX_URL}`
